import paymentService from "./axiosInstances/paymentService";

export const getTransactionDetailsByBillingReqIdApi = ({
  tenantCode,
  billingReqId,
  currentPage,
  sortByStatus,
}) => {
  return paymentService.get(
    `/transaction/tenant/${tenantCode}/billing-request/${billingReqId}?page=${currentPage}${
      sortByStatus ? `&sort=status,${sortByStatus}` : ""
    }&sort=created,DESC`
  );
};
export const getSubTransactionDetailsByTransactionIdApi = (
  transactionId,
  pageSize
) => {
  return paymentService.get(
    `/sub-transaction/transaction/${transactionId}/settlement-details?size=${pageSize}`
  );
};

/**
 * `tenant` is optional: payment-service falls back to the persisted tenant and
 * then to UPGRAD, so a caller that sends nothing gets exactly today's URL. Only
 * a tenant whose config sets `sendTenantOnRefundRequest` names itself.
 */
export const getRefundRequestDetails = ({
  userId,
  billingRequestId,
  refundId,
  tenant,
}) => {
  return paymentService.get(
    `/refund-request?userId=${userId}&billingRequestId=${billingRequestId}&refundApplicationId=${refundId}${
      tenant ? `&tenant=${tenant}` : ""
    }`
  );
};

export const postRefundRequestDetails = (payload) => {
  return paymentService.post("/refund-request/transaction", payload);
};

export const putRefundFinanceRecommendation = (payload) => {
  return paymentService.put("/refund-request/finance-recommendation", payload);
};

export const putRefundFinanceRecommended = (payload) => {
  return paymentService.put("/refund-request/recommended", payload);
};

/**
 * RD6: `speed` and `tenant` are both optional. A falsy pair must produce
 * exactly the URL that shipped before, because that is the one upGrad calls;
 * only a tenant whose config sets `sendTenantOnRefundRequest` names itself,
 * and only the instant Retry asks for a speed.
 */
export const postRefundToSource = ({
  transactionId,
  refundReqTxnId,
  payload,
  speed = null,
  tenant = null,
}) => {
  const query = [
    speed ? `speed=${encodeURIComponent(speed)}` : null,
    tenant ? `tenant=${encodeURIComponent(tenant)}` : null,
  ]
    .filter(Boolean)
    .join("&");

  return paymentService.post(
    `/refund-request/initiate/refund/${transactionId}/refund/${refundReqTxnId}${
      query ? `?${query}` : ""
    }`,
    payload
  );
};

export const postRevokeRefundRequest = (payload) => {
  return paymentService.put("/refund-request/clear", payload);
};

export const postRefundDetailsAddToXML = ({ payload }) => {
  return paymentService.post("/refund-request/initiate/add-xml", payload);
};

/**
 * Moves a failed REFUND_TO_SOURCE line onto the finance bank sheet: the line
 * flips to ADD_TO_XML and an ADD_TO_XML refund row is created in place of the
 * dead Razorpay one (spec case F19). All four bank fields are mandatory - the
 * sheet is the only instruction the bank gets - and payment-service answers
 * 422 BANK_FIELDS_REQUIRED without them, or 422 REFUND_IN_FLIGHT while the
 * line still holds a Razorpay refund that has not failed.
 */
export const postSwitchRefundToXml = (payload) => {
  return paymentService.post("/refund-request/switch-to-xml", payload);
};

export const putRefundRequestXMLdetails = (payload) => {
  return paymentService.put("/refund-request/add-xml", payload);
};

/**
 * Asks payment-service to poll the gateway now instead of waiting for the
 * 4-hourly job (spec screen 2, case B8). The endpoint is tenant-neutral
 * (confirmed with payment-service): no tenant is sent on the URL.
 */
export const postRefundManualProcess = () => {
  return paymentService.post("/refund-request/manual-process");
};
